import React from 'react';

import Modal from 'react-modal';

/** components */
import CustomTooltip from './CustomTooltip';
import ExternalRef from './ExternalRef';

/** helpers */
import { sanitizeHtml } from '../../helpers/format';

const LabelWithTooltip = ({ field, toggleFieldModal, isModalOpen }) => {
  return (
    <>
      <label htmlFor={`${field.name}`}>
        <span
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(field.label) }}
          onClick={() => toggleFieldModal(field.name)}
        ></span>
        <span className="required">{field.required ? '*' : ''}</span>
        &nbsp;
        <ExternalRef field={field} /> <CustomTooltip field={field} />
      </label>

      {field.modalContent && (
        <Modal
          isOpen={isModalOpen[field.name]}
          className="field-modal"
          contentLabel={field.modalContent}
          onRequestClose={() => toggleFieldModal(field.name)}
        >
          {field.modalContent}
        </Modal>
      )}
    </>
  );
};

export default LabelWithTooltip;
